// extracted by mini-css-extract-plugin
export default {"lone-star":"bphRrrsH6Piqq0juOma5","img-div":"FwNpApw8fWJ3RqwGmgSQ","type-default":"YV2Egv6rOsjA7emIQoAO","common_bganimation":"LzoItZJnRIBLZhvB5NrU"};